import "../Myprojects.css"
import { MdPictureAsPdf } from "react-icons/md";
import { MdOutlineSchool } from "react-icons/md";
import React, { useState,useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import api from "views/auth/Api";
import { message } from 'antd'
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import McqQuiz from "./McqQuiz";

const Details = ({data}) => {
 const [open , setOpen] = useState(false)
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="my-component"/>
  );
}


  return (
    <div>
      {/* <Header /> */}
        <div className="overviewMain">
       <div className="proOverview detailsMrg flex flex-row justify-between">
        <div className="proOverviewChild">
              <h4 className="h4Create">Material needed : </h4>
              <MyComponent htmlContent={data.project?.project?.details?.materialNeeded}/>

              <h4 className="h4Create">Project objectives : </h4>
                <MyComponent htmlContent={data.project?.project?.details?.studentObjectives}/>

              <h4 className="h4Create">Key vocabulary : </h4> 
              <MyComponent htmlContent={data.project?.project?.details?.keyVocabulary}/>

                </div>
       <div className="proOverviewChild">

                <h4 className="h4Create">Experiment steps : </h4> 
              <MyComponent htmlContent={data.project?.project?.details?.studentSteps}/>

              <h4 className="h4Create">Optional & Extras : </h4> 
              <MyComponent htmlContent={data.project?.project?.details?.optionalExtras}/>
                 </div>
      </div>
        <div className="overview-DevImgRight">
          <div className="overview-DevImg" >
        </div>
         <button onClick={() => setOpen(true)} className="btn-Quiz mt-[20px]">Start Quiz</button>
        </div>
        </div>
        {open ?  <McqQuiz questions={data.project?.project?.mcqProject} assignedProject={data.project?.id}/> : null}
    </div>
  );
};

export default Details;
